import { useState } from "react";
import {
  Stack,
  Button,
  TextField,
  Card,
  Box,
  Typography,
  CardContent,
  CardActions,
} from "@mui/material";
import { get } from "cross-domain-cookie";

const App = () => {
  const [cookies, setData] = useState({});
  const [form, setForm] = useState({});
  const [name, setName] = useState("");

  const getData = async () => {
    const result = await get({
      iframeUrl: "https://hket89.github.io/react-form-plugin/cross-domain",
      dataKey: "authKey",
    });
    setForm({ name });
    setData(result as {});
  };

  return (
    <Card variant="outlined">
      <CardContent>
        <Stack spacing={2}>
          <Typography variant="h4">Form</Typography>
          <Typography variant="body2">Please input your name</Typography>

          <TextField
            id="outlined-basic"
            label="Name"
            variant="outlined"
            fullWidth
            onChange={(e) => {
              const v = e.target.value;

              setName(v);
            }}
            value={name}
          />

          <Typography variant="body2">Form values below:</Typography>

          <Box>{JSON.stringify({ cookies, form }, null, 2)}</Box>
        </Stack>
      </CardContent>

      <CardActions>
        <Button variant="contained" fullWidth onClick={getData}>
          Click me
        </Button>
      </CardActions>
    </Card>
  );
};

export default App;
